module.exports = __webpack_public_path__ + "static/media/google-gmail.8daeddca.svg";